import { Location } from 'history';
import React from 'react';
import { connect } from 'react-redux';

import { redirectToLogin } from '../../../../actions/auth';
import { StoreState } from '../../../../meta/types/store';
import { NAVBAR_HEIGHT } from '../../../../styles/Navbar';
import { COLLAPSED_SIDEBAR_WIDTH, EXTENDED_SIDEBAR_WIDTH } from '../../../../styles/Sidebar';
import { styled } from '../../../../styles/Theme';
import NavbarContainer from '../../../nav/Navbar';
import SidebarContainer from '../../../nav/Sidebar';

type PropsFromState = {
  sidebarCollapsed: boolean;
  isLoggedIn: boolean;
};

type Props = PropsFromState & {
  children: React.ReactNode;
  location: Location;
};

const AuthRoutes = ({ isLoggedIn, children, sidebarCollapsed, location }: Props) => {
  if (!isLoggedIn) {
    redirectToLogin(location.pathname + location.search);
    return null;
  }

  return (
    <>
      <NavbarContainer location={location} />
      <section className="main-section">
        <MainSectionWithSidebarStyle
          className="main-section__with-sidebar"
          sidebarCollapsed={sidebarCollapsed}
        >
          <SidebarContainer />
          <section style={{ width: '100%' }}>{children}</section>
        </MainSectionWithSidebarStyle>
      </section>
    </>
  );
};

type StyleProps = {
  sidebarCollapsed: boolean;
};

const MainSectionWithSidebarStyle = styled.section<StyleProps>`
  padding-left: ${props =>
    props.sidebarCollapsed ? COLLAPSED_SIDEBAR_WIDTH : EXTENDED_SIDEBAR_WIDTH};
  margin-top: ${NAVBAR_HEIGHT};
  transition: padding 0.3s;
`;

function mapStateToProps(state: StoreState): PropsFromState {
  return {
    isLoggedIn: state.auth.isLoggedIn,
    sidebarCollapsed: state.ui.sidebarCollapsed,
  };
}

const enhance = connect(mapStateToProps);

export default enhance(AuthRoutes);
